import { Injectable } from '@angular/core';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Http, Response} from '@angular/http';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
import {Validators} from '@angular/forms';

interface CallType {
  calltypeid: number;
}

interface Auotorouting {
  autoroutingsettingid:  number;
  pickupstart:           string;
  pickupend:            string;
  dropoffstart:          string;
  dropoffend:           string;
  legbpickupstart:           string;
  legbpickupend:            string;
  legbdropoffend:           string;
  keepassignedtrips:      string;
  usevehicledriverskills: string;
  usedriveraddress:   string;
  speed: string;
  autoroutingsettingtimes: CallType[];
}


@Injectable()
export class AutoroutingService extends ParentService {

  constructor(private http: Http, private route: Router) {
    super();
  }

  getAutoroutingSetting() {
    return this.http.get(constant.URL_AUTOROUTING_SETTING, this.getHeader())
      .map(resp => resp.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  putAutoroutingSetting(data) {
    return this.http.put(constant.URL_AUTOROUTING_SETTING, data, this.headerPost())
      .map(resp => resp.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  postAutoroutingSetting(data) {
    return this.http.post(constant.URL_AUTOROUTING_SETTING, data, this.headerPost())
      .map(resp => resp.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  getAutoroutingJobs(beginDate, endDate, providerId, jobStatusId) {
    return this.http.get(constant.URL_AUTOROUTING + `/${beginDate}/${endDate}/${providerId}/${jobStatusId}`, this.getHeader())
      .map(resp => resp.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  getAutoroutingStatus() {
    return this.http.get(constant.URL_AUTOROUTING + `/AutoRoutingStatus`, this.getHeader())
      .map(resp => resp.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  getAutoroutingExport(id) {
    return this.http.get(`${constant.URL_AUTOROUTING_EXPORT}/${id}`, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error.json()));
  }

  postAutorouting(data) {
    return this.http.post(constant.URL_AUTOROUTING, data, this.headerPost())
      .map(resp => resp.json())
      .catch(error => this.validate401Error(error, this.route));
  }

  deleteAutoroutingJob(id) {
    return this.http.delete(`${constant.URL_AUTOROUTING}/${id}`,  this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * register connection to signal r on autorouting jobs
   * @param connId \
   * @param date
   */
  public registerJobsSignalR(connId, date, providerid) {
    return this.http
      .post(`${constant.URL_HUB_AUTOROUTING_JOBS}${connId}/${date}/${providerid}`, null, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public deleteJobsSignalR(connId, date, providerid) {
    return this.http
      .delete(`${constant.URL_HUB_AUTOROUTING_JOBS}${connId}/${date}/${providerid}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/autorouting/autorouting.service.ts